import { cn } from '@/lib/utils';

/**
 * Underline-style tab button matching the Sales Order Review page's tab bar
 * (`ReviewTabs`): render inside a `flex border-b` row. A plain button rather
 * than a Radix TabsTrigger so callers can intercept selection (e.g. to guard
 * unsaved edits) before switching; pair it with a controlled Tabs root +
 * TabsContent for the panels.
 */
export function UnderlineTabButton({
  value,
  activeTab,
  onSelect,
  children,
}: {
  value: string;
  activeTab: string;
  onSelect: (value: string) => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={() => onSelect(value)}
      className={cn(
        'border-b-2 px-3 py-2 text-sm',
        activeTab === value
          ? 'border-foreground font-medium text-foreground'
          : 'border-transparent text-muted-foreground hover:text-foreground',
      )}
    >
      {children}
    </button>
  );
}
